import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  splitString,
  breakLongWord,
  isFamilyEmoji,
  isFamilyEmojiFour,
} from "./ReportFunctionality/splitString";

const generatePhoto_ListPDF = (photoDetails, title) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // // Title Section
  // doc.setFont("helvetica", "bold");
  // doc.setFontSize(15);
  // doc.text("Inmate Photos Communication", 105, 15, { align: "center" });

  // // Inmate Details
  // doc.setFontSize(10);
  // doc.setFont("helvetica", "bold");
  // doc.text("Inmate Name:", 10, 30);
  // doc.setFont("helvetica", "normal");
  // doc.text(inmateName || "N/A", 45, 30);

  // doc.setFont("helvetica", "bold");
  // doc.text("Inmate ID:", 10, 40);
  // doc.setFont("helvetica", "normal");
  // doc.text(inmateId || "N/A", 45, 40);

  const addHeader = (doc, InmateName, InmateId) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.text("Inmate Photos Communication", 105, 15, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Inmate Name:", 10, 30);
    doc.setFont("helvetica", "normal");
    doc.text(InmateName || "N/A", 45, 30);

    doc.setFont("helvetica", "bold");
    doc.text("Inmate ID:", 10, 40);
    doc.setFont("helvetica", "normal");
    doc.text(InmateId || "N/A", 45, 40);
  };

  let startY = 50;
  const recordsPerPage = 1;
  let recordCount = 0;

  photoDetails.forEach((detail, index) => {
    // if (index > 0) {
    //   doc.addPage();
    // }
    // if (recordCount === recordsPerPage || startY > pageHeight - 60) {
    //   doc.addPage();
    //   startY = 20;
    //   recordCount = 0;
    // }
    if (recordCount === recordsPerPage || startY > pageHeight - 60) {
      doc.addPage();
      addHeader(doc, detail.InmateName, detail.InmateId); // <-- add this
      startY = 50; // Reset Y based on header height
      recordCount = 0;
    } else if (index === 0) {
      // For the first page
      addHeader(doc, detail.InmateName, detail.InmateId);
    }

    // Outer Border
    const borderX = 10;
    const borderWidth = 190;

    let xPosition = 13;
    let yPosition = startY + 18;
    const maxWidth = 68;
    const lineHeight = 7;
    let contentHeight = lineHeight;

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = splitString(detail.Subject);
    const elements = tempDiv.querySelectorAll(".emoji, .text");

    elements.forEach((element) => {
      if (element.classList.contains("emoji")) {
        const canvas = document.createElement("canvas");
        canvas.width = 40;
        canvas.height = 40;
        const ctx = canvas.getContext("2d");
        ctx.font = "20px Calibri, sans-serif";
        ctx.fillText(element.innerText, 0, 25);
        const imgData = canvas.toDataURL("image/png");

        if (xPosition + 8 > 13 + maxWidth) {
          xPosition = 13;
          yPosition += lineHeight;
          contentHeight += lineHeight;
        }
        doc.addImage(imgData, "PNG", xPosition, yPosition - 4.5, 7, 7);
        xPosition += 7;
      } else {
        const words = element.innerText.split(" ");

        words.forEach((word) => {
          const wordWidth = doc.getTextWidth(word + " ");
        
          const padding = 5; // Define padding once
          const adjustedMaxWidth = maxWidth - padding; // Use throughout for consistency
          
          if (wordWidth > adjustedMaxWidth) {
            // Break long word into chunks that fit within adjustedMaxWidth
            const brokenParts = breakLongWord(word, adjustedMaxWidth, doc);
          
            brokenParts.forEach((part) => {
              const partWidth = doc.getTextWidth(part);
          
              if (xPosition + partWidth > 13 + adjustedMaxWidth) {
                xPosition = 13;
                yPosition += lineHeight;
                contentHeight += lineHeight;
              }
          
              doc.text(part, xPosition, yPosition - 1); // Removed unnecessary space
              xPosition += partWidth;
            });
          } else {
          
            if (xPosition + wordWidth > 13 + maxWidth-5) {
              xPosition = 13;
              yPosition += lineHeight;
              contentHeight += lineHeight;
            }
        
            doc.text(word + " ", xPosition, yPosition - 1);
            xPosition += wordWidth;
          }
        });
      }
    });

    autoTable(doc, {
      startY: startY,
      margin: { left: borderX },
      body: [
        [
          {
            content: "Subject",
            styles: {
              fontStyle: "bold",
              fillColor: [240, 240, 240], /// color add
            },
          },
        ],
        [{ content: "", styles: { minCellHeight: contentHeight + 8 } }],
        [
          {
            content: "From",
            styles: {
              fontStyle: "bold",
              fillColor: [240, 240, 240],
            },
          },
        ],
        [
          {
            content: detail.From || "N/A",
          },
        ],
        [
          {
            content: "Photo Cost",
            styles: {
              fontStyle: "bold",
              fillColor: [240, 240, 240],
            },
          },
        ],
        [
          {
            content: `$${detail.PhotoCost || "N/A"}`,
          },
        ],
        [
          {
            content: "Send Date",
            styles: {
              fontStyle: "bold",
              fillColor: [240, 240, 240],
            },
          },
        ],
        [
          {
            content: detail.SendDate || "N/A",
          },
        ],
        [
          {
            content: "Status",
            styles: {
              fontStyle: "bold",
              fillColor: [240, 240, 240],
            },
          },
        ],
        [
          {
            content: detail.Status || "N/A",
          },
        ],
        [
          {
            content: "Facility Name",
            styles: {
              fontStyle: "bold",
              fillColor: [240, 240, 240],
            },
          },
        ],
        [
          {
            content: detail.FacilityName || "N/A",
          },
        ],
      ],
      theme: "plain",
      styles: {
        fontSize: 10,
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        valign: "top",
      },
      columnStyles: { 0: { cellWidth: 70 } },
      didDrawCell: (data) => {
        if (data.row.index === 0 && data.section === "body") {
          yPosition = data.cell.y + 7;
        }
      },
    });

    // Emojis and text wrapping logic (replace only this part)

    const finalY = doc.lastAutoTable.finalY;
    const borderHeight = finalY - startY;

    doc.setLineWidth(0.2);
    doc.rect(borderX, startY, borderWidth, borderHeight);

    const imageStartX = borderX + 72;
    const imageStartY = startY + 2;
    const imageWidth = borderWidth - 74;
    const imageHeight = borderHeight - 4;

    doc.line(imageStartX - 2, startY, imageStartX - 2, finalY);

    if (detail.base64 && detail.base64 !== "N/A") {
      doc.addImage(
        detail.base64,
        "JPEG",
        imageStartX,
        imageStartY,
        imageWidth,
        imageHeight
      );
    }

    startY = finalY + 10;
    recordCount++;
  });

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - 20, pageHeight - 10, {
      align: "right",
    });
  }

  doc.save(`${title}.pdf`);
};

export default generatePhoto_ListPDF;
